<template>
  <div style="height: calc(100% - 64px);">
    <div class="media-add-ep-list" ref="epList">
      <div :class="fromIsOpen ? 'from-close top-search' : 'top-search' " ref="searchForm">
        <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
          <el-form-item label="投放链接ID" prop="tfid">
            <el-input v-model="formInline.tfid" placeholder="请输入投放链接ID" clearable @keyup.enter.native="search"
              @clear="search" style="width: 180px;"></el-input>
          </el-form-item> 
          <el-form-item label="用户ID" prop="userId">
            <el-input v-model="formInline.userId" placeholder="请输入用户ID" clearable @keyup.enter.native="search"
              @clear="search" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="回传状态" prop="status" style="margin-right: 30px;">
						<el-select v-model="formInline.status" placeholder="请选择回传状态" clearable @change="search" style="width: 180px;">
							<el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
          <el-form-item label="广告计划ID" prop="promotionid"> 
            <el-input v-model="formInline.promotionid" placeholder="请输入广告计划ID" clearable @keyup.enter.native="search"
              @clear="search" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="用户注册时间：">
            <el-date-picker v-model="createTime" class="pickerData" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              style="margin-right: 10px; width: 400px" clearable @change="search">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="tableTh" :style="{ height: tableHeight + 'px' }">
        <el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle"
          v-loading="loading">
          <el-table-column prop="" label="序号" width="60">
            <template slot-scope="scope">
              <span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" width="200">
            <template slot-scope="scope">
              <div class="td-info" v-if="scope.row.userInfoVo">
                <p>用户ID：{{ scope.row.userid }}</p>
                <p>用户昵称：{{ scope.row.userInfoVo.nickName || '未绑定昵称' }}</p>
                <p>注册时间：{{ scope.row.userInfoVo.strAddTime }}</p>
                <p>用户系统类型：{{ scope.row.userInfoVo.mos }}</p>
              </div>
              <div class="td-info" v-else>
                <p>用户ID：</p>
                <p>用户昵称：</p>
                <p>注册时间：</p>
                <p>用户系统类型：</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="小程序信息" width="220">
            <template slot-scope="scope">
              <div class="td-info" v-if="scope.row.userInfoVo">
                <p>appid：{{ scope.row.userInfoVo.appId }}</p>
                <p>小程序名称：{{ scope.row.appName }}</p>
              </div>
              <div class="td-info" v-else>
                <p>appid：</p>
                <p>小程序名称：</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="推广信息" min-width="300">
            <template slot-scope="scope">
              <div class="td-info" v-if="scope.row.userInfoVo">
                <p><b>推广平台：</b>{{ scope.row.userInfoVo.promotionPlatform}}</p>
                <p><b>投放链接ID：</b>{{ scope.row.tfid }}</p>
                <p><b>clickId：</b>{{ scope.row.clickid }}</p>
                <p><b>广告计划ID：</b>{{ scope.row.promotionId }}</p>
              </div>
              <div class="td-info" v-else>
                <p><b>推广平台：</b></p>
                <p><b>投放链接ID：</b></p>
                <p><b>clickId：</b></p>
                <p><b>广告计划ID：</b></p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="adNumber" label="广告完播次数（IPU）" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.adNumber || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="playNumber" label="浏览集数" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.playNumber || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.status==0">未回传</span>
              <span v-if="scope.row.status==1">已回传</span>
              <span v-if="scope.row.status==2">已漏</span>
            </template>
          </el-table-column>
          <el-table-column label="广告播放详情" width="160">
            <template slot-scope="scope">
              <el-button type="defult" icon="el-icon-warning-outline" size="mini"
                @click="handleLook(scope.row)">详情</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <div style="padding: 0 15px;">
								<span class="danger-text" v-if="scope.row.status == 0">未回传</span>
								<span class="succes-text" v-if="scope.row.status == 1">已回传</span>
								<span class="warnning-text" v-if="scope.row.status == 2">已漏</span>
								<el-button type="text" v-if="scope.row.status == 0 || scope.row.status == 2" @click="repair(scope.row.id)" style="margin-left: 25px;">补回传</el-button>
							</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="foot-table" style="text-align:center;">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage"
            layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--详情-->
    <el-dialog title="详情" :visible.sync="dialogInfoVisible" width="1600px">
      <div class="top-search">
        <el-form :inline="true" :model="formInline" ref="detailformInline" size="small" class="demo-form-inline">
          <el-form-item label="广告播放时间：">
            <el-date-picker v-model="dataTime" class="pickerData" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              style="margin-right: 10px; width: 300px" clearable @change="detailSearch">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="detailSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" @click="detailResetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableTh" v-height>
        <el-table :data="tableLinkData.result" border stripe style="width: 100%;" height="100%" class="tableStyle"
          v-loading="linkLoading">
          <el-table-column prop="" label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户信息">
            <template slot-scope="scope">
              <div class="td-info" v-if="scope.row.userInfoVo">
                <p>用户ID：{{ scope.row.userid }}</p>
                <p>用户昵称：{{ scope.row.userInfoVo.nickName || '未绑定昵称' }}</p>
                <p>注册时间：{{ scope.row.userInfoVo.strAddTime }}</p>
                <p>用户系统类型：{{ scope.row.userInfoVo.mos }}</p>
              </div>
              <div class="td-info" v-else>
                <p>用户ID：{{ scope.row.userid }}</p>
                <p>用户昵称：</p>
                <p>注册时间：</p>
                <p>用户系统类型：</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="推广信息">
            <template slot-scope="scope">
              <div class="td-info">
                <p v-if="scope.row.userInfoVo"><b>推广平台：</b>{{ scope.row.userInfoVo.promotionPlatform }}</p>
                <p v-else><b>推广平台：</b></p>
                <p><b>投放链接ID：</b>{{ scope.row.tfid }}</p>
                <p><b>clickId：</b>{{ scope.row.clickid }}</p>
                <p><b>广告计划ID：</b>{{ scope.row.promotionid }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="userAdNumber" label="广告展示次数"></el-table-column>
          <el-table-column prop="addtime" label="广告播放记录"></el-table-column>
          <!-- <el-table-column label="操作" width="230">
            <template slot-scope="scope">
              <div style="padding: 0 15px;">
                <span class="succes-text" v-if="scope.row.statusB == 1">已回传</span>
                <span class="danger-text" v-if="scope.row.statusB == 0">未回传</span>
                <span class="succes-text" v-if="scope.row.statusB == 2">已手动回传</span>
                <el-button type="text" v-if="scope.row.statusB == 0" @click="repair(scope.row.id)"
                  style="margin-left: 25px;">补回传</el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="foot-table" style="text-align:center;">
          <el-pagination @current-change="handleCurrentChangeLink" @size-change="handleSizeChangeLink"
            :page-sizes="[20, 50, 100, 200, 500]" :page-size="tableLinkData.pageSize" background
            :current-page="linkCurrentPage" layout="sizes, prev, pager, next, jumper, ->, total"
            :total="tableLinkData.totalNum">
          </el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
        <el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// list
import { list } from "@/api/dysvzk/data/return";
export default {
  name: 'AdReturnListTx',
  props:['fromIsOpen'],
  data() {
    return {
      loading: false,
      linkLoading: false,
      dataTime: [],
      createTime: [],
      statusBList: [],
      formInline: {
        userId: '',
        status: '',
        tfid: '',
        agentId: '',
        promotionid: '',
        startTime: '',
        endTime: '',
        appid: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId,
      },
      tableData: {
        pageSize: 20,
        pageNo: 1,
        totalPage: 1,
        totalNum: 0,
        result: [
        ]
      },
      tableLinkData: {
        pageSize: 20,
        pageNo: 1,
        totalPage: 1,
        totalNum: 0,
        result: [
        ]
      },
      currentPage: 1,
      linkCurrentPage: 1,
      dialogInfoVisible: false,
      rowForm: {},
      statusBOptions: [
        {
          value: 1,
          label: '已回传'
        },
        {
          value: 2,
          label: '已手动回传'
        },
        {
          value: 0,
          label: '未回传'
        }
      ],
      statusOptions: [
        {
          value: 0,
          label: '不符合回传'
        },
        {
          value: 1,
          label: '已回传'
        },
        {
          value: 2,
          label: '已漏回传'
        },
      ],
      isShowDialogAgent: false,
      linkId: '',
      tableHeight:0,//表格高度
    }
  },
  computed: {},
  watch: {
    fromIsOpen(newValue) {
			console.log("展开、收起筛选面板",newValue)
			this.$nextTick(() => {
        this.calcTableHeight(); // 表单展开/收起后重新计算表格高度
      });
		},
  },
  created() {
    if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
      this.isShowDialogAgent = false
    } else {
      this.isShowDialogAgent = true
    }
  },
  mounted: function () {
    this.calcTableHeight(); // 初始化计算表格高度
    window.addEventListener('resize', this.calcTableHeight); // 监听窗口大小变化
    this.getTableData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight); // 移除监听
  },
  methods: {
    search () {
      this.currentPage = 1
      this.getTableData()
    },
    resetQuery: function () {
      this.$refs['formInline'].resetFields()
      this.createTime = []
      this.getTableData()
    },
    // pageSize切换
    handleSizeChange(val) {
      this.tableData.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    handleCurrentChange(value) {
      this.currentPage = value
      this.getTableData()
    },
    //详情搜索和重置
    detailSearch () {
      this.linkLoading = true,
        this.linkCurrentPage = 1
      this.getTableLinkData(this.linkId)
    },
    detailResetQuery: function () {
      this.$refs['detailformInline'].resetFields()
      this.linkLoading = true,
        this.dataTime = []
      this.getTableLinkData(this.linkId)
    },
    // 详情pageSize切换
    handleSizeChangeLink(val) {
      this.tableData.pageSize = val
      this.linkCurrentPage = 1
      this.linkLoading = true,
        this.getTableLinkData(this.linkId)
    },
    handleCurrentChangeLink(value) {
      this.linkCurrentPage = value
      this.linkLoading = true
      this.getTableLinkData(this.linkId)
    },
    handleLook(row) {
      this.dialogInfoVisible = true
      this.linkLoading = true
      this.rowForm = row
      this.linkLoading = true
      this.linkId = row.id
      this.linkCurrentPage = 1
      this.getTableLinkData(row.userid)
    },
    getTableData() {
      this.loading = true
      let json2 = {
        pageNo: this.currentPage,
        pageSize: this.tableData.pageSize
      };
      // this.formInline.statusB = this.statusBList.toString()
      this.formInline.startTime = this.createTime ? this.createTime[0] : ''
      this.formInline.endTime = this.createTime ? this.createTime[1] : ''
      let json1 = this.formInline;
      let paramJson = { ...json1, ...json2 };
      this.axios({
        method: 'get',
        url: '/stat/payPostBackTx/getList',
        params: paramJson
      }).then((response) => {
        console.log("payPostBackTx",response.data)
        if (response.data.head.flag === 0) {
          this.tableData = response.data.content
          this.loading = false
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
      
    },
    repair(id) {
      // addRepair({
      //   infoId: id
      // }).then(response => {
      //   if (response.data.head.flag === 0) {
      //     this.getTableLinkData(this.linkId)
      //   } else {
      //     this.$message.error(response.data.head.desc)
      //   }
      // });
      this.axios({
        method: 'get',
        url: '/stat/payPostBackTx/addRepair',
        params: {
          userId:id
        }
      }).then((response) => {
        console.log("补回传",response.data)
        if (response.data.head.flag === 0) {
          this.getTableData()
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
      
    },
    tabChange(val) {
      this.tabValue = val;
    },
    //获取链接详情列表
    getTableLinkData(id) {
      let json2 = {
        pageNo: this.linkCurrentPage,
        pageSize: this.tableLinkData.pageSize
      };
      this.formInline.statusB = this.statusBList.toString()
      this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
      this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
      let json1 = this.formInline;
      let paramJson = { ...json1, ...json2, userId:id, type:3 };
      console.log("paramJson", paramJson)
      list(paramJson).then(response => {
        if (response.data.head.flag === 0) {
          this.tableLinkData = response.data.content
          this.linkLoading = false
        } else {
          this.$message.error(response.data.head.desc)
        }
      });
    },
    // 计算表单的高度
		calcTableHeight() {
      const windowHeight = this.$refs.epList.offsetHeight; // 视口高度
      const searchFormHeight = this.$refs.searchForm.offsetHeight; // 搜索表单高度
      // 计算表格高度
      this.tableHeight = windowHeight - searchFormHeight;
      console.log("算表格高度", this.tableHeight)
    },

  }
}
</script>
<style lang="scss" scoped>
.media-add-ep-list {
	width: 100%;
	height: calc(100% - 64px);
	position: relative;
	color: #409eff;
	font-size: 14px;
	display: flex;
  flex-direction: column;
	.caretbtn {
		position: absolute;
		right: 30px;
		top: 0;
		margin-left: 20px;
	}
	.top-search {
    flex-shrink: 0; /* 防止表单区域被压缩 */
    overflow: hidden;
    transition: height 0.3s;
  }
	.from-close {
		height: 0;
		overflow: hidden;
	}
	.tableTh {
    flex: 1; /* 表格区域自动填充剩余空间 */
    position: relative;
  }
}
</style>
